import script from "./MarketingGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./MarketingGuideModal.vue?vue&type=style&index=0&id=27b1ea94&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b1ea94"]])

export default __exports__